"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCascaderSnapshot = exports.getCascaderSnapshot = exports.getCascaderData = exports.batchDeletePermissionRole = exports.unsubscribeRecordByIds = exports.subscribeRecordByIds = exports.getSubscriptions = exports.getCommentsByIds = exports.getContentDisposition = exports.getShareDstViewDataPack = exports.getDstViewDataPack = exports.batchEditFieldPermissionRole = exports.getFieldPermissionMap = exports.fetchFieldPermissionRoleList = exports.updateFieldPermissionSetting = exports.deleteFieldPermissionRole = exports.editFieldPermissionRole = exports.addFieldPermissionRole = exports.setFieldPermissionStatus = exports.fetchDatasheetMeta = exports.fetchRecords = exports.fetchUserList = exports.getActivityList = exports.fetchChangesets = exports.fetchEmbedForeignDatasheetPack = exports.fetchShareForeignDatasheetPack = exports.fetchForeignDatasheetViewPack = exports.fetchForeignDatasheetPack = exports.fetchEmbedDatasheetPack = exports.fetchTemplateDatasheetPack = exports.fetchShareDatasheetPack = exports.fetchDatasheetPack = void 0;
const axios_1 = __importDefault(require("axios"));
const Url = __importStar(require("./url.data"));
const qs_1 = __importDefault(require("qs"));
const urlcat_1 = __importDefault(require("urlcat"));
const baseURL = process.env.NEXT_PUBLIC_NEXT_API;
/**
 * get space datasheet pack
 * @param dstId
 * @param recordIds
 * @returns
 */
function fetchDatasheetPack(dstId, recordIds) {
    console.log({ baseURL });
    return axios_1.default.get((0, urlcat_1.default)(Url.DATAPACK, { dstId }), {
        baseURL,
        params: {
            recordIds
        },
        paramsSerializer: params => {
            return qs_1.default.stringify(params, { arrayFormat: 'repeat' });
        }
    });
}
exports.fetchDatasheetPack = fetchDatasheetPack;
/**
 * get share datasheet pack
 *
 * @param shareId
 * @param dstId
 * @returns
 */
function fetchShareDatasheetPack(shareId, dstId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.READ_SHARE_DATAPACK, { shareId, dstId }), { baseURL });
}
exports.fetchShareDatasheetPack = fetchShareDatasheetPack;
/**
 * get template datasheet pack
 *
 * @param dstId
 * @returns
 */
const fetchTemplateDatasheetPack = (dstId) => {
    return axios_1.default.get((0, urlcat_1.default)(Url.READ_TEMPLATE_DATAPACK, { dstId }), { baseURL });
};
exports.fetchTemplateDatasheetPack = fetchTemplateDatasheetPack;
/**
 * get embed datasheet pack
 */
function fetchEmbedDatasheetPack(embedId, dstId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.READ_EMBED_DATAPACK, { embedId, dstId }), { baseURL });
}
exports.fetchEmbedDatasheetPack = fetchEmbedDatasheetPack;
/**
 * get related datasheet pack in the same space. support resource: datasheet, form, mirror
 *
 * @param resourceId
 * @param foreignDatasheetId
 * @returns
 */
function fetchForeignDatasheetPack(resourceId, foreignDatasheetId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.READ_FOREIGN_DATASHEET_PACK, { resourceId, foreignDatasheetId }), { baseURL });
}
exports.fetchForeignDatasheetPack = fetchForeignDatasheetPack;
/**
 * get related datasheet view pack in the same space. support resource: datasheet, form, mirror
 *
 * @param resourceId
 * @param foreignDatasheetId
 * @returns
 */
function fetchForeignDatasheetViewPack(resourceId, foreignDatasheetId, viewId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.READ_FOREIGN_DATASHEET_VIEW_PACK, { resourceId, foreignDatasheetId, viewId }), { baseURL });
}
exports.fetchForeignDatasheetViewPack = fetchForeignDatasheetViewPack;
/**
 * get related datasheet pack in the share.
 * support resource: datasheet, form, mirror
 * @param shareId
 * @param resourceId
 * @param foreignDatasheetId
 * @returns
 */
function fetchShareForeignDatasheetPack(shareId, resourceId, foreignDatasheetId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.READ_SHARE_FOREIGN_DATASHEET_PACK, { shareId, resourceId, foreignDatasheetId }), { baseURL });
}
exports.fetchShareForeignDatasheetPack = fetchShareForeignDatasheetPack;
function fetchEmbedForeignDatasheetPack(embedId, resourceId, foreignDatasheetId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.READ_EMBED_FOREIGN_DATASHEET_PACK, { embedId, resourceId, foreignDatasheetId }), { baseURL });
}
exports.fetchEmbedForeignDatasheetPack = fetchEmbedForeignDatasheetPack;
/**
 * get changeset list
 * @param resourceId
 * @param resourceType
 * @param startRevision inclusive
 * @param endRevision   exclusive
 * @returns
 */
function fetchChangesets(resourceId, resourceType, startRevision, endRevision, sourceId, shareId) {
    const url = shareId ? (0, urlcat_1.default)(Url.READ_SHARE_CHANGESET, { shareId, resourceId }) : (0, urlcat_1.default)(Url.READ_CHANGESET, { resourceId });
    return axios_1.default.get(url, {
        baseURL,
        params: {
            resourceType,
            startRevision,
            endRevision,
            sourceId,
        },
        // serialize params revisions: [1,2,3] to normal GET params revisions=1&revisions=2&revisions=3
        paramsSerializer: params => {
            return qs_1.default.stringify(params, { arrayFormat: 'repeat' });
        },
    });
}
exports.fetchChangesets = fetchChangesets;
/**
 * get specified record's history and comments
 * support: datasheet, mirror
 *
 * @param resourceId
 * @param recId
 * @param params
 * @param cancelSource
 * @returns
 */
function getActivityList(resourceId, recId, params, cancelSource) {
    const query = {
        baseURL,
        params,
    };
    if (cancelSource) {
        query.cancelToken = cancelSource.token;
    }
    return axios_1.default.get((0, urlcat_1.default)(Url.GET_RECORD_ACTIVITY_LIST, { resourceId, recId }), query);
}
exports.getActivityList = getActivityList;
/**
 * get user infos by uuids
 *
 * @param nodeId
 * @param uuids
 * @returns
 */
function fetchUserList(nodeId, uuids) {
    return axios_1.default.get((0, urlcat_1.default)(Url.GET_USER_LIST, { nodeId }), {
        baseURL,
        params: {
            uuids,
        },
        // serialize params revisions: [1,2,3] to normal GET params revisons=1&revisions=2&revisions=3
        paramsSerializer: params => {
            return qs_1.default.stringify(params, { arrayFormat: 'repeat' });
        },
    });
}
exports.fetchUserList = fetchUserList;
/**
 * get data records
 * @param dstId
 * @param recordIds
 * @returns
 */
function fetchRecords(dstId, recordIds) {
    return axios_1.default.post((0, urlcat_1.default)(Url.READ_RECORDS, { dstId }), recordIds, { baseURL });
}
exports.fetchRecords = fetchRecords;
/**
 * get datasheet meta info
 *
 * @param dstId
 * @returns
 */
function fetchDatasheetMeta(dstId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.READ_DATASHEET_META, { dstId }), { baseURL });
}
exports.fetchDatasheetMeta = fetchDatasheetMeta;
/**
 * open or close field permission
 *
 * @param dstId
 * @param fieldId
 * @param open
 * @param includeExtend
 * @returns
 */
function setFieldPermissionStatus(dstId, fieldId, open, includeExtend) {
    const params = includeExtend ? { includeExtend } : {};
    return axios_1.default.post((0, urlcat_1.default)(Url.FIELD_PERMISSION_STATUS, { dstId, fieldId, status: open ? 'enable' : 'disable' }), params);
}
exports.setFieldPermissionStatus = setFieldPermissionStatus;
/**
 * add field permission role
 *
 * @param dstId
 * @param fieldId
 * @param option
 * @returns
 */
function addFieldPermissionRole(dstId, fieldId, option) {
    return axios_1.default.post((0, urlcat_1.default)(Url.FIELD_PERMISSION_ADD_ROLE, { dstId, fieldId }), option);
}
exports.addFieldPermissionRole = addFieldPermissionRole;
/**
 * edit field permission role
 *
 * @param dstId
 * @param fieldId
 * @param option
 * @returns
 */
function editFieldPermissionRole(dstId, fieldId, option) {
    return axios_1.default.post((0, urlcat_1.default)(Url.FIELD_PERMISSION_EDIT_ROLE, { dstId, fieldId }), option);
}
exports.editFieldPermissionRole = editFieldPermissionRole;
/**
 * delete field permission role
 * @param dstId
 * @param fieldId
 * @param unitId
 * @returns
 */
function deleteFieldPermissionRole(dstId, fieldId, unitId) {
    return axios_1.default.delete((0, urlcat_1.default)(Url.FIELD_PERMISSION_DELETE_ROLE, { dstId, fieldId }), {
        data: {
            unitId,
        },
    });
}
exports.deleteFieldPermissionRole = deleteFieldPermissionRole;
/**
 * update field permission's other config
 * @param dstId
 * @param fieldId
 * @param formSheetAccessible
 * @returns
 */
function updateFieldPermissionSetting(dstId, fieldId, formSheetAccessible) {
    return axios_1.default.post((0, urlcat_1.default)(Url.FIELD_PERMISSION_UPDATE_SETTING, { dstId, fieldId }), { formSheetAccessible });
}
exports.updateFieldPermissionSetting = updateFieldPermissionSetting;
/**
 * get field(column) permissions' all roles list
 *
 * @param dstId
 * @param fieldId
 * @returns
 */
function fetchFieldPermissionRoleList(dstId, fieldId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.FIELD_PERMISSION_ROLE_LIST, { dstId, fieldId }));
}
exports.fetchFieldPermissionRoleList = fetchFieldPermissionRoleList;
/**
 * get field permissions map
 *
 * @param dstIds
 * @param shareId
 * @returns
 */
function getFieldPermissionMap(dstIds, shareId) {
    return axios_1.default.get(Url.GET_FIELD_PERMISSION_MAP, {
        params: {
            dstIds: dstIds.join(','),
            shareId,
        },
    });
}
exports.getFieldPermissionMap = getFieldPermissionMap;
/**
 *
 * batch edit field permissions role
 *
 * @param dstId
 * @param fieldId
 * @param option
 * @returns
 */
function batchEditFieldPermissionRole(dstId, fieldId, option) {
    return axios_1.default.post((0, urlcat_1.default)(Url.BATCH_EDIT_PERMISSION_ROLE, { dstId, fieldId }), option);
}
exports.batchEditFieldPermissionRole = batchEditFieldPermissionRole;
/**
 * get datasheet view datapack
 *
 * @param dstId
 * @param viewId
 * @returns
 */
function getDstViewDataPack(dstId, viewId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.GET_DST_VIEW_DATA_PACK, { dstId, viewId }), { baseURL });
}
exports.getDstViewDataPack = getDstViewDataPack;
/**
 * get share datasheet view data pack
 *
 * @param dstId
 * @param viewId
 * @param shareId
 * @returns
 */
function getShareDstViewDataPack(dstId, viewId, shareId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.GET_SHARE_DST_VIEW_DATA_PACK, { dstId, viewId, shareId }), { baseURL });
}
exports.getShareDstViewDataPack = getShareDstViewDataPack;
function getContentDisposition(url) {
    return axios_1.default.post(Url.GET_CONTENT_DISPOSITION, { url }, { baseURL });
}
exports.getContentDisposition = getContentDisposition;
function getCommentsByIds(dstId, recordId, commentIds) {
    return axios_1.default.get((0, urlcat_1.default)(Url.GET_COMMENTS_BY_IDS, { dstId, recordId }) + `?commentIds=${commentIds}`, {
        baseURL,
    });
}
exports.getCommentsByIds = getCommentsByIds;
/**
 * get datasheet/mirror's being subscription(followed) record ids
 *
 * @param dstId
 * @param mirrorId
 * @returns
 */
const getSubscriptions = (dstId, mirrorId) => mirrorId
    ? axios_1.default.get((0, urlcat_1.default)(Url.GET_MIRROR_SUBSCRIPTIONS, { mirrorId }), { baseURL })
    : axios_1.default.get((0, urlcat_1.default)(Url.GET_DATASHEET_SUBSCRIPTIONS, { dstId }), { baseURL });
exports.getSubscriptions = getSubscriptions;
/**
 *
 * subscribe(follow) datasheet/mirror's record
 *
 * @param param0
 * @returns
 */
const subscribeRecordByIds = ({ datasheetId, mirrorId, recordIds }) => mirrorId
    ? axios_1.default.post((0, urlcat_1.default)(Url.SUBSCRIBE_MIRROR_RECORDS, { mirrorNodeId: mirrorId }), { recordIds }, { baseURL })
    : axios_1.default.post((0, urlcat_1.default)(Url.SUBSCRIBE_DATASHEET_RECORDS, { dstId: datasheetId }), { recordIds }, { baseURL });
exports.subscribeRecordByIds = subscribeRecordByIds;
/**
 * unsubscribe(cancel follow) datasheet/mirror's record
 * @param param0
 * @returns
 */
const unsubscribeRecordByIds = ({ datasheetId, mirrorId, recordIds }) => mirrorId
    ? axios_1.default.delete((0, urlcat_1.default)(Url.UNSUBSCRIBE_MIRROR_RECORDS, { mirrorNodeId: mirrorId }), { data: { recordIds }, baseURL })
    : axios_1.default.delete((0, urlcat_1.default)(Url.UNSUBSCRIBE_DATASHEET_RECORDS, { dstId: datasheetId }), { data: { recordIds }, baseURL });
exports.unsubscribeRecordByIds = unsubscribeRecordByIds;
/**
 * batch delete field permissions
 * @param dstId
 * @param fieldId
 * @param option
 * @returns
 */
const batchDeletePermissionRole = (dstId, fieldId, option) => {
    return axios_1.default.delete((0, urlcat_1.default)(Url.BATCH_DELETE_PERMISSION_ROLE, { dstId, fieldId }), { data: option });
};
exports.batchDeletePermissionRole = batchDeletePermissionRole;
// Get cascader data
const getCascaderData = ({ spaceId, datasheetId, linkedViewId, linkedFieldIds, }) => axios_1.default.get((0, urlcat_1.default)(Url.CASCADER_DATA, {
    spaceId,
    datasheetId,
}), {
    baseURL,
    params: {
        linkedViewId,
        linkedFieldIds,
    },
});
exports.getCascaderData = getCascaderData;
// get cascader snapshot data
const getCascaderSnapshot = ({ datasheetId, fieldId, linkedFieldIds, }) => axios_1.default.get((0, urlcat_1.default)(Url.CASCADER_SNAPSHOT, {
    datasheetId,
    fieldId,
}), {
    baseURL,
    params: {
        linkedFieldIds,
    },
});
exports.getCascaderSnapshot = getCascaderSnapshot;
// update cascader snapshot data
const updateCascaderSnapshot = ({ spaceId, datasheetId, fieldId, // snapshot field ID
linkedDatasheetId, linkedViewId, }) => axios_1.default.put((0, urlcat_1.default)(Url.UPDATE_CASCADER_SNAPSHOT, {
    spaceId,
    datasheetId,
    fieldId,
}), undefined, {
    baseURL,
    params: {
        linkedDatasheetId,
        linkedViewId,
    },
});
exports.updateCascaderSnapshot = updateCascaderSnapshot;
//# sourceMappingURL=datasheet_api.js.map